// Giocarté — unico script (vanilla, senza dipendenze)
// Menu mobile, anno footer, form dimostrativa, smooth-anchor con rispetto reduced-motion.

(function () {
  "use strict";

  // 1. Menu hamburger accessibile
  var btn = document.querySelector("[data-menu-btn]");
  var nav = document.querySelector("[data-site-nav]");
  if (btn && nav) {
    btn.addEventListener("click", function () {
      var open = nav.getAttribute("data-open") === "true";
      nav.setAttribute("data-open", String(!open));
      btn.setAttribute("aria-expanded", String(!open));
    });
    // Chiudi il menu dopo il click su un link (mobile)
    nav.addEventListener("click", function (e) {
      if (e.target.closest("a")) {
        nav.setAttribute("data-open", "false");
        btn.setAttribute("aria-expanded", "false");
      }
    });
  }

  // 2. Tema chiaro/scuro: toggle con persistenza (default da OS via script in <head>)
  var themeBtn = document.querySelector("[data-theme-btn]");
  function setTheme(t) {
    document.documentElement.dataset.theme = t;
    try { localStorage.setItem("giocarte-theme", t); } catch (e) {}
    if (themeBtn) {
      var dark = t === "dark";
      themeBtn.setAttribute("aria-pressed", String(dark));
      themeBtn.setAttribute("aria-label", dark ? "Passa al tema chiaro" : "Passa al tema scuro");
    }
  }
  if (themeBtn) {
    setTheme(document.documentElement.dataset.theme || "light");
    themeBtn.addEventListener("click", function () {
      setTheme(document.documentElement.dataset.theme === "dark" ? "light" : "dark");
    });
  }

  // 3. CTA Contattami: scroll fino a fondo pagina (non solo alla sezione)
  document.querySelectorAll('a[href="#contatti"]').forEach(function (link) {
    link.addEventListener("click", function (e) {
      if (!document.querySelector("#contatti")) return;
      e.preventDefault();
      var reduce = window.matchMedia("(prefers-reduced-motion:reduce)").matches;
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: reduce ? "auto" : "smooth" });
    });
  });

  // 4. Anno corrente nel footer
  document.querySelectorAll("[data-year]").forEach(function (el) {
    el.textContent = String(new Date().getFullYear());
  });

})();
